import { Chart } from "@scuf/charts";
import { Card, Loader } from "@scuf/common";

export default function LoadingChart() {
  return (
    <>
      <Card>
        <Card.Content>
          <Chart></Chart>
          <Loader loading={true}>
            <div className="placeholder" />
          </Loader>
        </Card.Content>
      </Card>
    </>
  );
}
